// extracted by mini-css-extract-plugin
export default {"root":"TemplateUpload_root__6a7QX","order":"TemplateUpload_order__EQl9a","wrapperBlocks":"TemplateUpload_wrapperBlocks__y43cJ"};